export default {
    computed: {
        plano_internet() {
            return this.$store.state.plano_internet;
        },
        plano_internet_id() {
            return this.$route.params.id;
        }
    }
};
